module.exports = __webpack_public_path__ + "img/bg.c751919f.png";